import Vue from 'vue'
import App from './App.vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import axios from 'axios'

import router from './router'
import store from './store/index'
import FormBuilder from 'element-form-builder' 

import config from "@/common/config"

import 'element-ui/lib/theme-chalk/index.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

Vue.use(Element, { locale })
Vue.use(FormBuilder)

Vue.config.productionTip = false

Vue.axios = Vue.prototype.$http = axios.create({
   baseURL: config.API_URL
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
